import React from "react";

import { Button } from "react-bootstrap";

import _ from "lodash";

import cx from "classnames";

import styles from "./brandkit.components.module.scss";

export default function Footer ({
  resetHandler,
  updating,
  saveChangesHandler,
  saveDisable,
  marginCondition
}){

  return (
    <div
      className={cx(
        styles.footerButtonContainer,
        marginCondition && styles.footerButtonContainerText,
        (saveDisable) && styles.footerButtonContainerDisabled
      )}
    >
      <Button
        variant="secondary"
        className={styles.resetButton}
        type="reset"
        onClick={resetHandler}
        disable={saveDisable}
      >
        {"Reset"}
      </Button>
      <Button
        variant="primary"
        className={styles.saveButton}
        type="submit"
        onClick={!updating ? saveChangesHandler : null}
        disable={saveDisable}
      >
        {updating ? "Saving..." : "Save Changes"}
      </Button>
    </div>
  );
};